import React, { memo, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import { filterMessages } from 'components/Filters/filterMessages';
import { FilterUrlParams } from 'modules/search/types';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Text } from '@daedalus/atlas/Text';
import { Toggle } from '@daedalus/atlas/Toggle';
const _exp = /*#__PURE__*/() => Flex.Row;
const ContentWrapper = /*#__PURE__*/styled(_exp())({
  name: "ContentWrapper",
  class: "ceff936",
  propsAsIs: true
});
const _exp5 = /*#__PURE__*/() => Text;
const StyledTitle = /*#__PURE__*/styled(_exp5())({
  name: "StyledTitle",
  class: "s1j6ioxk",
  propsAsIs: true
});
const _exp6 = /*#__PURE__*/() => Text;
const StyledSubtitle = /*#__PURE__*/styled(_exp6())({
  name: "StyledSubtitle",
  class: "s1nkciq",
  propsAsIs: true
});
interface FreeCancellationToggleProps {
  /** The current free cancellation value */
  value: BooleanUrlParam;
  /** Callback fired on toggle change */
  onChange: (updatedFilters: FilterUrlParams) => void;
}
const FreeCancellationToggleComponent = ({
  value,
  onChange
}: FreeCancellationToggleProps) => {
  const {
    formatMessage
  } = useIntl();
  const {
    isMobile
  } = useDeviceLayout();
  const handleToggle = useCallback(() => {
    const updatedFilters = {
      freeCancellation: (value ? undefined : '1') as BooleanUrlParam
    };
    onChange(updatedFilters);
  }, [value, onChange]);
  return <div>
      <Flex.Row gap="s250" alignItems="center" onClick={handleToggle}>
        <StyledTitle variant="titleL">
          {formatMessage(filterMessages.freeCancellationTitle)}
        </StyledTitle>
      </Flex.Row>
      <ContentWrapper alignItems="center" justifyContent="space-between">
        <div onClick={handleToggle} role="presentation">
          <StyledSubtitle variant={isMobile ? 'bodyM' : 'bodyS'}>
            {formatMessage(filterMessages.freeCancellationSubtitle)}
          </StyledSubtitle>
        </div>

        <Toggle checked={Boolean(value)} id="freeCancellation" onChange={handleToggle} />
      </ContentWrapper>
    </div>;
};
export const FreeCancellationToggle = memo(FreeCancellationToggleComponent);

require("./FreeCancellationToggle.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./FreeCancellationToggle.tsx");